export function hasRole(allowedRoles, authRoles) {
  return allowedRoles.some((userRole) => authRoles.includes(userRole));
}
